
/**
 * Calculates the total price based on selected options
 */
export const calculatePrice = (
  selectedPackage: string,
  tshirtPrinting: boolean,
  photoBooth: boolean,
  music: boolean,
  posters: boolean,
  guestCount: number,
  printQuantity: number
): string => {
  let basePrice = 0;
  
  // Package prices
  switch (selectedPackage) {
    case "standard":
      basePrice = 99.99;
      break;
    case "premium":
      basePrice = 199.99;
      break;
    case "deluxe":
      basePrice = 299.99;
      break;
    default:
      basePrice = 99.99;
  }
  
  // Additional services
  if (tshirtPrinting) basePrice += 15 * printQuantity;
  if (photoBooth) basePrice += 150;
  if (music) basePrice += 200;
  if (posters) basePrice += 10 * printQuantity;
  
  // Guest count adjustment
  if (guestCount > 30) {
    basePrice += (guestCount - 30) * 5; // $5 per additional guest over 30
  }
  
  // Apply t-shirt discount (buy 3 get the 4th free)
  if (tshirtPrinting && printQuantity >= 4) {
    const freeShirts = Math.floor(printQuantity / 4);
    basePrice -= freeShirts * 15; // Discount for free shirts
  }
  
  return basePrice.toFixed(2);
};
